<div class="title-body flexRow" [ngStyle]="style">
  <div class="text-md fontBolder main-title">{{ mainTitle }}</div>
  <div class="secondary-title" *ngIf="secondaryTitle != ''">{{ secondaryTitle }}</div>
  <div class="flexFull"></div>
  <div class="operation clickEle" *ngIf="operation != ''">{{ operation }}</div>
</div>
